import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginWithEmail } from '../api/authApi';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    try {
      const res = await loginWithEmail(email, password); // await 추가
      navigate('/spaces');
    } catch (err: any) {
      // 서버에서 반환된 에러 메시지 처리
      if (err.response && err.response.data && err.response.data.message) {
        setError(err.response.data.message); // 서버 메시지 표시
      } else {
        setError('ID 또는 비밀번호가 잘못되었습니다, 다시 확인해 주세요.');
      }
    }
  };

  return (
    <div className="w-screen h-screen flex items-center justify-center bg-gray-100">
      <div className="w-full max-w-sm">
        {/* 로그인 폼 */}
        <form
          onSubmit={handleSubmit}
          className="bg-white shadow-lg rounded-lg px-8 py-6 flex flex-col"
          style={{ height: '450px' }}
        >
          {/* 진행도 표시 (회원가입에만 해당되므로 생략) */}
          <h2 className="text-2xl font-semibold mb-6">로그인</h2>

          {error && <p className="text-red-500 mb-4">{error}</p>} {/* 에러 메시지 표시 */}

          <div className="flex-grow">
            {/* 이메일 입력 */}
            <input
              type="email"
              className="mb-3 px-4 py-2 border rounded w-full"
              placeholder="이메일을 입력하세요."
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            {/* 비밀번호 입력 */}
            <input
              type="password"
              className="mb-4 px-4 py-2 border rounded w-full"
              placeholder="비밀번호를 입력하세요."
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {/* 하단 버튼 영역 (중앙 정렬로 수정) */}
          <div className="flex justify-center w-full mt-4">
            <button
              type="submit"
              className="bg-green-500 hover:bg-green-600 text-white py-2 px-4 rounded font-semibold"
            >
              로그인
            </button>
          </div>

          {/* 회원가입 페이지로 이동 */}
          <div className="mt-4 text-center">
            <button
              type="button"
              className="text-blue-500 hover:underline"
              onClick={() => navigate('/signup')}
            >
              계정이 없으신가요? 회원가입
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
